import React, { useRef } from "react"
import { useFormikContext } from "formik"

const useFactsheetObserver = (currentFieldsets, { globalValues = {}}) => {
	const { values, setFieldValue, setValues } = useFormikContext()
	const factsheetValue = values["physischegefaehrdungsanalyse_gefaehrdungstyp_gefahrenstoff_datenblattliegtvor"]
	const prevFactsheetValue = useRef(factsheetValue);
	let res = React.useMemo(() => {
		let newFieldsets = currentFieldsets
		if (factsheetValue === true && prevFactsheetValue.current !== factsheetValue) {
			setValues({
				...values,
				"physischegefaehrdungsanalyse_massnahmenausreichend_merkmale": "Nicht ausreichend"
			})
		}
		prevFactsheetValue.current = factsheetValue

		return {
			fieldsets: newFieldsets,
		}
	}, [
		currentFieldsets, factsheetValue
	])

	return res
}

export default useFactsheetObserver
